var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLogoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 338,
    viewBox: "0 0 281 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_769_8896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.487 7.87194L276.55 84.424V245.142L141.486 325.429L4.45103 245.124V84.442L141.487 7.87194Z",
    fill: "white",
    stroke: "#504D64",
    strokeWidth: 8.77266
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.943 325.195L48.0243 270.243V107.272L141.925 52.0453L232.975 107.233V271.15L141.943 325.195Z",
    fill: "#FEE175",
    stroke: "#504D64",
    strokeWidth: 8.77266
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9608 294.856V135.353L141.551 102.989L192.04 135.302V294.905L141.553 325.197L88.9608 294.856Z",
    fill: "#FAC914",
    stroke: "#504D64",
    strokeWidth: 8.77266
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8428 134.036L141.597 155.759M141.597 326.826V155.759M192.517 134.037L141.597 155.759",
    stroke: "#504D64",
    strokeWidth: 8.77266
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_769_8896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280.725,
    height: 337.747,
    fill: "white",
    transform: "translate(0.137451)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogoLarge);
export default __webpack_public_path__ + "static/media/login_logo_large.1cc072a1c8c8ea49ee4ebeb319a769fb.svg";
export { ForwardRef as ReactComponent };